
import { computed, defineComponent, ref, watch } from 'vue'

export default defineComponent({
    props: {
        isConnected: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }) {
        const is_hidden = ref(true)

        const text = computed(() => {
            if (props.isConnected) return 'Интернет соединение восстановлено'
            return 'Отсутствует интернет соединение'
        })

        watch(
            () => props.isConnected,
            (newVal) => {
                if (newVal) {
                    setTimeout(() => {
                        is_hidden.value = true
                    }, 1000)
                } else {
                    is_hidden.value = false
                }
            }
        )

        return {
            is_hidden,
            text,
        }
    },
})
